/// <reference path="../../app.definition.ts" />

export enum UserNotiTypeEnum {
    SHARE_WALK_THROUGH = "SHARE_WALK_THRU",
    AVOID_SKIP_SHARE = "AVOID_SKIP_SHARE",
    SHOW_SPLASH_SCREEN = "SHOW_SPLASH_SCREEN"
}


import { Invitation } from "./invitation";
import { Serializable } from "./Serializable";

export class User implements Serializable<User> {

    password: string;
    userId: number;                     // “AWS-COGNITO-IDENTITY-B”,
    firstName: string;             // "John"
    middleName: string;
    lastName: string;              // "Doe"
    approvedProvider;     // "Optional, for provider accounts Default value= false"
    providerIdentity: string;      // "Optional, for provider accounts"
    policies: any[] = [];
    googlePhoto: any;
    resource: string;
    type: string;
    street: string;
    city: string;
    passwordSet;
    contact: string;
    middleInitials: string;
    preferredEmail: string;
    state: string;
    photo: any;
    photoMimeType: string;
    code: string;
    id: number;
    zip;
    acceptedPrivacy;
    acceptedGdpr;
    coveredEntity = false;
    isContextAdmin; // field to use in view if restrict wrt to admin
    documentShared; // field to use in sharedUser
    inviteStatus; // used in Team Member View
    isActive; // to distinguish temporary and permanent user
    sharedChecked; //used in careFeed add
    teamRoleId;
    teamRole;
    prevTeamRoleId;
    permissionType: string;
    invitation: Invitation;
    ownerId;
    profileId: number;
    fullName;
    token: string;
    ownedSubjects: string;
    recoveryEmail: string;
    isFormerTeamMember: boolean;
    userNotifications: any[] = [];
    providerId: number;
    bgColor: string;
    userTypeId;
    analyticsId: number;
    isPrivacyPolicyUpdated: boolean = false;
    isTermsOfServiceUpdated: boolean = false;
    isGdprComplianceUpdated: boolean = false;
    coCaptain: boolean = false;
    customerId: string;
    autosharedDocList: any[] = [];
    initialName: string;
    serviceRole: string;
    captain: boolean = false;
    tempPhoto: string = null;
    userSignature: object = null;
    orgPartyId: number;
    organizationId: number;
    organizationName: string;
    organizationShortName: string;
    countryId: number;
    euCountry: boolean = false;
    providerStatus: number;
    permissionEndDate: string;
    exitDate: string;
    isDocDeleted: boolean;
    invitationStatus: number;
    isIndividualMember: boolean;
    unassign: boolean;
    isAdmin: boolean;
    groupPermissions;
    jobTitle: string;
    partyId: number;
    isDeactivated: boolean;
    userExperience: boolean;
    isNotificationDisabled: boolean;
    permissionObj? : {
        text: string;
        value: string;
        color: string;
        icon?: string;
    };
    roleGroups: any;
    isInvitedDeleted: boolean;
    cPassword: string;

    public _fullName() {
        this.fullName = '';
        if (!!this.firstName || !!this.lastName) {
            if (!!this.firstName)
                this.fullName = this.firstName;
            if (!!this.lastName)
                this.fullName = this.fullName + ' ' + this.lastName;
        } else {
            this.fullName = this.providerIdentity;
        }
    }

    deserialize(input) {
        this.sharedChecked = false;
        this.isActive = false;
        this.unassign = false;
        (input.id) && (this.id = input.id);
        (input.zip) && (this.zip = input.zip);
        (input.profileId) && (this.profileId = input.profileId);
        (input.acceptedPrivacy) && (this.acceptedPrivacy = input.acceptedPrivacy);
        (input.acceptedGdpr) && (this.acceptedGdpr = input.acceptedGdpr);
        if (input.firstName) {
            this.initialName = input.firstName.charAt(0);
        }
        if (input.lastName) {
            this.initialName += input.lastName.charAt(0);
        }

        (!!input.id || !!input.userId) && (this.userId = (input.id || input.userId));
        (input.ownerId) && (this.ownerId = input.ownerId);
        (input.resource) && (this.resource = input.resource);
        (input.password) && (this.password = input.password);
        (input.documentShared) && (this.documentShared = input.documentShared);
        this.firstName = input.firstName;
        (input.middleName) && (this.middleName = input.middleName);
        this.lastName = input.lastName;
        (input.approvedProvider) && (this.approvedProvider = input.approvedProvider);
        (input.providerIdentity) && (this.providerIdentity = input.providerIdentity);
        (input.type) && (this.type = input.type);
        (input.inviteStatus) && (this.inviteStatus = input.inviteStatus);
        (input.isActive) && (this.isActive = input.isActive);
        (input.unassign) && (this.unassign = input.unassign);
        (input.passwordSet) && (this.passwordSet = input.passwordSet);
        (input.teamRoleId) && (this.teamRoleId = input.teamRoleId);
        this.prevTeamRoleId = this.teamRoleId;
        (input.teamRole) && (this.teamRole = input.teamRole);
        (input.recoveryEmail) && (this.recoveryEmail = input.recoveryEmail);
        (input.serviceRole) && (this.serviceRole = input.serviceRole);
        (input.providerStatus) && (this.providerStatus = input.providerStatus);
        this.partyId = input.partyId;
        (input.organizationId || input.organizationId == 0) && (this.organizationId = input.organizationId);
        this.permissionEndDate = input.permissionEndDate;
        this.exitDate = input.exitDate;
        this.isDocDeleted = input.isDocDeleted;
        this.invitationStatus = input.invitationStatus;
        this.isIndividualMember = input.isIndividualMember;
        this.permissionType = input.permissionType || input.serviceRole || 'NOT_SHARED';
        this.coCaptain = input.coCaptain;

        (!!input.code) && (this.code = input.code);
        (!!input.token) && (this.token = input.token);


        this.photoMimeType = "image/png";
        (input.city) && (this.city = input.city);
        (input.photoMimeType) && (this.photoMimeType = input.photoMimeType);
        input.photo && (this.photo = input.photo);

        (input.invitationRecord) && (this.invitation = new Invitation().deserialize(input.invitationRecord));
        if (!this.invitation) {
            (input.invitation) && (this.invitation = new Invitation().deserialize(input.invitation));
        }
        (input.street) && (this.street = input.street);
        (input.contact) && (this.contact = input.contact);
        (input.middleInitials) && (this.middleInitials = input.middleInitials);
        (input.preferredEmail) && (this.preferredEmail = input.preferredEmail);
        (input.state) && (this.state = input.state);

        (input.coveredEntity) && (this.coveredEntity = input.coveredEntity);
        (input.ownedSubjects) && (this.ownedSubjects = input.ownedSubjects);
        !!input.analyticsId && (this.analyticsId = input.analyticsId);

        this.isFormerTeamMember = input.isFormerTeamMember;
        this.isDeactivated = input.isDeactivated;
        this.isPrivacyPolicyUpdated = input.isPrivacyPolicyUpdated;
        this.isTermsOfServiceUpdated = input.isTermsOfServiceUpdated;
        this.isGdprComplianceUpdated = input.isGdprComplianceUpdated;
        if (!!input.policies) {
            for (var i = 0; i < input.policies.length; i++) {
                if (input.policies[i].accepted != false)
                    this.policies.push(input.policies[i]);
            }
        }

        this.userNotifications = input.userNotifications;
        (input.providerId) && (this.providerId = input.providerId);
        (input.bgColor) && (this.bgColor = input.bgColor);
        (input.userTypeId) && (this.userTypeId = input.userTypeId);
        (input.customerId) && (this.customerId = input.customerId);
        (input.captain) && (this.captain = input.captain);
        !!input.userSignature && (this.userSignature = input.userSignature);
        !!input.organizationName && (this.organizationName = input.organizationName);
        !!input.organizationShortName && (this.organizationShortName = input.organizationShortName);
        !!input.countryId && (this.countryId = input.countryId);
        this.euCountry = input.euCountry;
        !!input.orgPartyId && (this.orgPartyId = input.orgPartyId);
        this.groupPermissions = input.groupPermissions;
        this.jobTitle = !!input.jobTitle ? input.jobTitle : "";
        this.userExperience = input.userExperience || false;
        this.isNotificationDisabled = input.isNotificationDisabled;
        this._fullName();
        return this;
    }

    constructor() {
    }

    getObject(userId, resource) {
        this.userId = userId;

        return this;
    }
}

